import React, { FC, ReactNode } from 'react'
import styles from './contentBlock.module.scss'
import clsx from 'clsx'

interface Props {
  header: ReactNode
  className?: string
  id?: string
}

export const ContentBlock: FC<Props> = ({
  header,
  className,
  id,
  children
}) => (
  <div className={clsx('ui vertical fitted segment', className)} id={id}>
    <h3 className={styles.header}>{header}</h3>
    {children}
  </div>
)
